export enum BIINSURANCE_ROUTES {
  BIINSURANCE = "/business-interruption-insurance",
  BIINSURANCE_FLOP = "/business-interruption-insurance/flop-insurance",
  BIINSURANCE_MFLOP = "/business-interruption-insurance/mflop-insurance",
}
  